export default __webpack_public_path__ + "static/media/Lato-Italic.c045106a.woff2";